import axios from "axios"
import router from '../src/router/index'

export const api = {
	async queryAPIServerGet(url, data, callback = null) {
		try {
			let response = await axios({
				method: 'GET',
				params: data,
				url
			})
			if (callback !== null) {
				callback(response)
			} else {
				return response
			}
		} catch (error) {
			console.log(error)
			router.push({name: 'Login', params: { consecutiveVisit: true}}).catch(() => { })
		}
	},
	async queryAPIServerPost(url, data, callback = null) {
		try {
			let response = await axios({
				method: 'POST',
				data,
				url
			})
			if (callback !== null) {
				callback(response)
			} else {
				return response
			}
		} catch (error) {
			console.log(error)
			router.push({name: 'Login', params: { consecutiveVisit: true}}).catch(() => { })
		}
	},
	async queryAPIServerPut(url, data, callback = null) {
		try {
			let response = await axios({
				method: 'PUT',
				data,
				url
			})
			if (callback !== null) {
				callback(response)
			} else {
				return (new Promise((resolve) => { resolve(response) }))
				// return response
			}
		} catch (error) {
			console.log(error)
		}
	},
	async queryAPIServerUploadFile(url, data, callback = null) {
		console.log("api method", data)
		let response = await axios({
			method: 'POST',
			// headers: {
			// 	'Content-Type': 'multipart/form-data'
			// },
			data,
			url
		})
		if (callback !== null) {
			callback(response)
		} else {
			return response
		}
	}
}
